import React from "react";
import { useWindowContext } from "../../../contexts";
import { Icon } from "../../../ui/components/icon/Icon";
import { Typography } from "../../../ui/components/typography/Typography";
import { joinClasses } from "../../../ui/utils/joinClasses";
export const MenuButton = ({ children, iconPath, isActive, ...props }) => {
    const { menuIsCollapsed } = useWindowContext();
    return (React.createElement("button", { className: joinClasses([
            "flex h-10 items-center gap-x-3 rounded-lg px-3 transition-colors hover:bg-surface-mid hover:text-neutral-moderate",
            "focus-visible:z-1",
            isActive
                ? "bg-surface-low text-neutral-moderate"
                : "text-neutral-subdued",
        ]), ...(menuIsCollapsed ? { title: children } : {}), ...props },
        React.createElement(Icon, { className: "shrink-0", path: iconPath, size: "sm" }),
        React.createElement(Typography, { appearance: "none", as: "span", className: "truncate font-semibold", typographyType: "body-sm" }, children)));
};
